const checkIfNoElements = (params, data) => {
  const paramValues = Object.values(params);

  return data.length === 0 && paramValues.length === 0;
};

export default checkIfNoElements;
